import React from 'react';

const ThankYou = () => (
  <div className="p-8 text-center text-xl">
    Thank you for your purchase! Check your email for the course link.
  </div>
);

export default ThankYou;
